export function isTechnician(assignee) {
    return assignee.type === "technician" /* AssigneeType.TECHNICIAN */;
}
export function isSubcontractor(assignee) {
    return assignee.type === "subcontractor" /* AssigneeType.SUBCONTRACTOR */;
}
